import {
    LOAD_CARDS_SUCCEEDED,
    REMOVE_CREDIT_CARD_SUCCEEDED
} from '../actions/constants/action-types';

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_CARDS_SUCCEEDED: {
            return {
                ...state,
                creditcards: action.payload
            };
        }
        case REMOVE_CREDIT_CARD_SUCCEEDED: {
            const newCreditCards = state.creditcards.filter(card =>
                card.registrationId !== action.registrationId);

            return {
                ...state,
                creditcards: newCreditCards
            };
        }

        default:
            return state;
    }
};
